import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#C97D60] text-white hover:bg-[#B56B50] focus:ring-[#C97D60] shadow-md hover:shadow-lg transform hover:-translate-y-0.5',
    secondary: 'bg-[#8B9D83] text-white hover:bg-[#7A8C72] focus:ring-[#8B9D83] shadow-sm',
    outline: 'border-2 border-[#C97D60] text-[#C97D60] hover:bg-[#FAF8F5] focus:ring-[#C97D60]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-semibold'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      // Redirige al carrito de compra
      window.location.href = 'https://www.metodolowtox.com/cart/51631184806199:1';
    }
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} onClick={handleClick} {...props} data-id="element-234">
      {children}
    </button>;
}